module.exports = __webpack_public_path__ + "img/Event_Icon_Mobile_Blue.7f763a6b.png";